import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { businessProfile as company } from '../config/businessProfile';
import '../styles/pages/storeInfo.css';

const pages = [
  ['contacts', 'Контакты и реквизиты'],
  ['delivery', 'Доставка и оплата'],
  ['returns', 'Возврат товаров'],
  ['privacy', 'Персональные данные'],
  ['offer', 'Условия покупки'],
];

function Contacts() {
  return (
    <>
      <p>
        По вопросам работы MaxMarket и обращений покупателей свяжитесь с нами:
      </p>
      <div className="store-info-contacts">
        <a href={`tel:${company.phone}`}>{company.phoneLabel}</a>
        <a href={`mailto:${company.email}`}>{company.email}</a>
      </div>
      <h2>Реквизиты оператора</h2>
      <dl className="store-info-details">
        {[
          ['Наименование', company.name],
          ['ИНН', company.inn],
          ['ОГРНИП', company.ogrnip],
          ['Адрес для обращений', company.address],
          ['Банк', company.bank],
          ['Расчётный счёт', company.account],
          ['БИК', company.bik],
          ['Корреспондентский счёт', company.correspondentAccount],
        ]
          .filter(([, value]) => value)
          .map(([label, value]) => (
            <div key={label}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
      </dl>
      <p>
        До отправки товара на возврат уточните адрес приёмки по телефону или
        электронной почте.
      </p>
    </>
  );
}

function Delivery() {
  return (
    <>
      <h2>Получение заказа</h2>
      <p>
        В MaxMarket предусмотрена доставка Яндексом в пункты выдачи и курьером.
        Постаматы исключены из выбора. Ozon Доставка находится на этапе
        подключения.
      </p>
      <p>
        Стоимость и ориентировочный срок зависят от адреса, выбранного ПВЗ, веса
        и размеров упаковки. Расчёт показывается при оформлении до подтверждения
        заказа.
      </p>
      <h2>Оплата</h2>
      <p>
        Приём онлайн-платежей готовится к подключению. Сейчас списание денег и
        оформление оплаченных заказов на опубликованном сайте недоступны.
      </p>
      <p>
        После подключения оплаты её способы, окончательная сумма товаров и
        доставки будут показаны до подтверждения платежа. Данные банковской
        карты будут вводиться на странице платёжного провайдера.
      </p>
      <h2>Проверка товара</h2>
      <p>
        Возможность вскрытия, примерки и частичного выкупа зависит от ПВЗ и
        опций заказа. Эти услуги нельзя считать включёнными до их отображения
        при оформлении. Частичный выкуп в MaxMarket пока не запущен.
      </p>
    </>
  );
}

function Returns() {
  return (
    <>
      <p>
        Возврат осуществляется с учётом Закона РФ «О защите прав потребителей».
        Условия ниже описывают права покупателя; приём заказов через
        опубликованный сайт готовится к запуску.
      </p>
      <h2>Если товар не подошёл</h2>
      <p>
        При дистанционной покупке от товара надлежащего качества можно
        отказаться до его передачи, а после получения — в течение семи дней. Для
        возврата сохраняются товарный вид и потребительские свойства. Для
        товаров с индивидуально-определёнными свойствами предусмотрены
        исключения.
      </p>
      <h2>Если обнаружен недостаток</h2>
      <p>
        Свяжитесь с продавцом или оператором MaxMarket и опишите проблему.
        Возврат товара с недостатками по требованию продавца производится за его
        счёт.
      </p>
      <h2>Как обратиться</h2>
      <p>
        Напишите на <a href={`mailto:${company.email}`}>{company.email}</a>:
        укажите дату заказа, товар, количество и причину обращения. Согласуйте
        способ и адрес передачи товара до отправки.
      </p>
      <p>
        Стоимость обратной перевозки и сумма денежного возврата зависят от
        причины обращения и применимых правил. Бесплатное вскрытие в ПВЗ не
        означает бесплатную обратную доставку.
      </p>
      <p>
        При отказе от товара надлежащего качества денежный возврат производится
        в установленный законом срок — не позднее десяти дней со дня
        предъявления требования, за исключением допускаемых законом расходов на
        обратную доставку.
      </p>
      <p>
        <a
          href="https://zpp.rospotrebnadzor.ru/news/federal/572363"
          target="_blank"
          rel="noreferrer"
        >
          Разъяснение Роспотребнадзора о дистанционных покупках ↗
        </a>
      </p>
    </>
  );
}

function Privacy() {
  return (
    <>
      <p>
        Оператор сайта — {company.name}, ИНН {company.inn}, ОГРНИП{' '}
        {company.ogrnip}. Вопросы о персональных данных:{' '}
        <a href={`mailto:${company.email}`}>{company.email}</a>.
      </p>
      <h2>Данные и цели</h2>
      <p>
        В интерфейсе MaxMarket предусмотрены имя, телефон, данные аккаунта,
        состав корзины и адрес доставки. Они используются для работы аккаунта,
        оформления и сопровождения заказа и обращений покупателя. Пароли не
        должны передаваться сотрудникам магазина.
      </p>
      <h2>Хранение в браузере</h2>
      <p>
        Сайт использует локальное хранилище браузера для корзины, избранного и
        сессии аккаунта. Удалить эти сведения можно в настройках браузера; при
        этом потребуется войти повторно.
      </p>
      <h2>Доставка и платежи</h2>
      <p>
        При оформлении доставки необходимые сведения получателя передаются
        подключённой службе доставки. Сведения банковской карты должны
        обрабатываться платёжным провайдером. На опубликованном экземпляре приём
        заказов и онлайн-платежей пока не запущен.
      </p>
      <h2>Обращения</h2>
      <p>
        Для уточнения, исправления или удаления данных направьте запрос
        оператору по электронной почте. Обращения рассматриваются с учётом
        требований законодательства и обязанностей по хранению документов.
      </p>
    </>
  );
}

function Offer() {
  return (
    <>
      <p>
        MaxMarket готовится к приёму заказов. До запуска оплаты и подтверждения
        условий продавцов заключение договоров покупки через опубликованный сайт
        не производится.
      </p>
      <h2>Информация о товаре</h2>
      <p>
        Перед покупкой покупатель должен видеть продавца, характеристики,
        выбранный вариант, количество, цену и условия получения товара.
        Окончательная стоимость товаров и доставки показывается до оплаты.
      </p>
      <h2>Публичная оферта</h2>
      <p>
        Окончательная публичная оферта с распределением обязанностей между
        оператором площадки и продавцами будет размещена до начала продаж.
        Текущая информационная страница не заменяет этот документ.
      </p>
      <h2>Связаться с оператором</h2>
      <p>
        {company.name}, ИНН {company.inn}, ОГРНИП {company.ogrnip}.
      </p>
      <p>
        <a href={`mailto:${company.email}`}>{company.email}</a> ·{' '}
        <a href={`tel:${company.phone}`}>{company.phoneLabel}</a>
      </p>
    </>
  );
}

export default function StoreInfoPage({ section }) {
  const title = pages.find(([id]) => id === section)?.[1] || pages[0][1];
  const body = {
    contacts: <Contacts />,
    delivery: <Delivery />,
    returns: <Returns />,
    privacy: <Privacy />,
    offer: <Offer />,
  }[section] || <Contacts />;
  return (
    <article className="store-info-page">
      <Link to="/" className="store-info-back">
        ← На витрину
      </Link>
      <h1>{title}</h1>
      <nav className="store-info-nav" aria-label="Информация для покупателей">
        {pages.map(([id, label]) => (
          <NavLink key={id} to={`/${id}`}>
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="store-info-body">{body}</div>
    </article>
  );
}
